export const COUNTRY_LIST = [
  { name: 'Andorra', iso2: 'AD' },
  { name: 'United Arab Emirates', iso2: 'AE' },
  { name: 'Albania', iso2: 'AL' },
  { name: 'Armenia', iso2: 'AM' },
  { name: 'Angola', iso2: 'AO' },
  { name: 'Argentina', iso2: 'AR' },
  { name: 'Australia', iso2: 'AU' },
  { name: 'Bosnia and Herzegovina', iso2: 'BA' },
  { name: 'Barbados', iso2: 'BB' },
  { name: 'Bulgaria', iso2: 'BG' },
  { name: 'Bahrain', iso2: 'BH' },
  { name: 'Bolivia', iso2: 'BO' },
  { name: 'Brazil', iso2: 'BR' },
  { name: 'Bahamas', iso2: 'BS' },
  { name: 'Belarus', iso2: 'BY' },
  { name: 'Canada', iso2: 'CA' },
  { name: 'Congo (Kinshasa)', iso2: 'CD' },
  { name: 'Switzerland', iso2: 'CH' },
  { name: 'Chile', iso2: 'CL' },
  { name: 'China', iso2: 'CN' },
  { name: 'Colombia', iso2: 'CO' },
  { name: 'Costa Rica', iso2: 'CR' },
  { name: 'Germany', iso2: 'DE' },
  { name: 'Dominican Republic', iso2: 'DO' },
  { name: 'Ecuador', iso2: 'EC' },
  { name: 'Egypt', iso2: 'EG' },
  { name: 'Spain', iso2: 'ES' },
  { name: 'European Union', iso2: 'EU' },
  { name: 'United Kingdom', iso2: 'GB' },
  { name: 'Georgia', iso2: 'GE' },
  { name: 'Guinea', iso2: 'GN' },
  { name: 'Hong Kong', iso2: 'HK' },
  { name: 'Croatia', iso2: 'HR' },
  { name: 'Hungary', iso2: 'HU' },
  { name: 'Indonesia', iso2: 'ID' },
  { name: 'Israel', iso2: 'IL' },
  { name: 'India', iso2: 'IN' },
  { name: 'Iceland', iso2: 'IS' },
  { name: 'Japan', iso2: 'JP' },
  { name: 'Kenya', iso2: 'KE' },
  { name: 'Cambodia', iso2: 'KH' },
  { name: 'South Korea', iso2: 'KR' },
  { name: 'Kazakhstan', iso2: 'KZ' },
  { name: 'Liechtenstein', iso2: 'LI' },
  { name: 'Morocco', iso2: 'MA' },
  { name: 'Moldova', iso2: 'MD' },
  { name: 'Montenegro', iso2: 'ME' },
  { name: 'North Macedonia', iso2: 'MK' },
  { name: 'Mauritania', iso2: 'MR' },
  { name: 'Mexico', iso2: 'MX' },
  { name: 'Malaysia', iso2: 'MY' },
  { name: 'Nigeria', iso2: 'NG' },
  { name: 'Norway', iso2: 'NO' },
  { name: 'Nepal', iso2: 'NP' },
  { name: 'New Zealand', iso2: 'NZ' },
  { name: 'Oman', iso2: 'OM' },
  { name: 'Peru', iso2: 'PE' },
  { name: 'Philippines', iso2: 'PH' },
  { name: 'Romania', iso2: 'RO' },
  { name: 'Serbia', iso2: 'RS' },
  { name: 'Russia', iso2: 'RU' },
  { name: 'Saudi Arabia', iso2: 'SA' },
  { name: 'Singapore', iso2: 'SG' },
  { name: 'Slovenia', iso2: 'SI' },
  { name: 'Senegal', iso2: 'SN' },
  { name: 'Suriname', iso2: 'SR' },
  { name: 'El Salvador', iso2: 'SV' },
  { name: 'Thailand', iso2: 'TH' },
  { name: 'Tajikistan', iso2: 'TJ' },
  { name: 'Turkiye', iso2: 'TR' },
  { name: 'Taiwan', iso2: 'TW' },
  { name: 'Tanzania', iso2: 'TZ' },
  { name: 'Ukraine', iso2: 'UA' },
  { name: 'Uganda', iso2: 'UG' },
  { name: 'United States', iso2: 'US' },
  { name: 'Uruguay', iso2: 'UY' },
  { name: 'Uzbekistan', iso2: 'UZ' },
  { name: 'Venezuela', iso2: 'VE' },
  { name: 'Vietnam', iso2: 'VN' },
  { name: 'South Africa', iso2: 'ZA' },
  { name: 'Zambia', iso2: 'ZM' },
  { name: 'Zimbabwe', iso2: 'ZW' },
];

export const COUNTRY_CODE_TO_NAME: Record<string, string> = Object.fromEntries(
  COUNTRY_LIST.map(({ name, iso2 }) => [iso2, name])
);

export const TAX_IDS = [
  'AD_NRT',
  'AE_TRN',
  'AL_TIN',
  'AM_TIN',
  'AO_TIN',
  'AR_CUIT',
  'AU_ABN',
  'AU_ARN',
  'BA_TIN',
  'BB_TIN',
  'BG_UIC',
  'BH_VAT',
  'BO_TIN',
  'BR_CNPJ',
  'BR_CPF',
  'BS_TIN',
  'BY_TIN',
  'CA_BN',
  'CA_GST_HST',
  'CA_PST_BC',
  'CA_PST_MB',
  'CA_PST_SK',
  'CA_QST',
  'CD_NIF',
  'CH_UID',
  'CH_VAT',
  'CL_TIN',
  'CN_TIN',
  'CO_NIT',
  'CR_TIN',
  'DE_STN',
  'DO_RCN',
  'EC_RUC',
  'EG_TIN',
  'ES_CIF',
  'EU_OSS_VAT',
  'EU_VAT',
  'GB_VAT',
  'GE_VAT',
  'GN_NIF',
  'HK_BR',
  'HR_OIB',
  'HU_TIN',
  'ID_NPWP',
  'IL_VAT',
  'IN_GST',
  'IS_VAT',
  'JP_CN',
  'JP_RN',
  'JP_TRN',
  'KE_PIN',
  'KH_TIN',
  'KR_BRN',
  'KZ_BIN',
  'LI_UID',
  'LI_VAT',
  'MA_VAT',
  'MD_VAT',
  'ME_PIB',
  'MK_VAT',
  'MR_NIF',
  'MX_RFC',
  'MY_FRP',
  'MY_ITN',
  'MY_SST',
  'NG_TIN',
  'NO_VAT',
  'NO_VOEC',
  'NP_PAN',
  'NZ_GST',
  'OM_VAT',
  'PE_RUC',
  'PH_TIN',
  'RO_TIN',
  'RS_PIB',
  'RU_INN',
  'RU_KPP',
  'SA_VAT',
  'SG_GST',
  'SG_UEN',
  'SI_TIN',
  'SN_NINEA',
  'SR_FIN',
  'SV_NIT',
  'TH_VAT',
  'TJ_TIN',
  'TR_TIN',
  'TW_VAT',
  'TZ_VAT',
  'UA_VAT',
  'UG_TIN',
  'US_EIN',
  'UY_RUC',
  'UZ_TIN',
  'UZ_VAT',
  'VE_RIF',
  'VN_TIN',
  'ZA_VAT',
  'ZM_TIN',
  'ZW_TIN',
];

export const TAX_ID_OPTIONS = TAX_IDS.map((entry) => {
  const [iso2] = entry.split('_');
  const country = COUNTRY_CODE_TO_NAME[iso2];
  if (!country) return null;

  return {
    value: entry,
    code: entry.replace(/_/g, ' '),
    country,
    flag: `https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/1x1/${iso2.toLowerCase()}.svg`,
  };
}).filter(Boolean) as {
  value: string;
  code: string;
  country: string;
  flag: string;
}[];
